// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Switch_wrap__1Xjyo","checked":"Switch_checked__1ytRv","slider":"Switch_slider__3I-Y8"};